var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrangeDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 137,
    viewBox: "0 0 114 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 10.5938 2.18359)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 31.1836 2.18359)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 51.7734 2.18359)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 72.3672 2.18359)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 92.9609 2.18359)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 113.551 2.18359)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 10.5938 22.7755)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 31.1836 22.7755)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 51.7734 22.7755)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 72.3672 22.7755)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 92.9609 22.7755)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 113.551 22.7755)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 10.5938 43.3673)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 31.1836 43.3673)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 51.7734 43.3673)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 72.3672 43.3673)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 92.9609 43.3673)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 113.551 43.3673)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 10.5938 63.9592)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 31.1836 63.9592)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 51.7734 63.9592)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 72.3672 63.9592)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 92.9609 63.9592)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 113.551 63.9592)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 10.5938 84.551)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 31.1836 84.551)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 51.7734 84.551)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 72.3672 84.551)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 92.9609 84.551)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 113.551 84.551)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 10.5938 105.143)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 31.1836 105.143)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 51.7734 105.143)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 72.3672 105.143)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 92.9609 105.143)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 113.551 105.143)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 10.5938 125.735)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 31.1836 125.735)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 51.7734 125.735)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 72.3672 125.735)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 92.9609 125.735)",
    fill: "#E26824"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29592,
    cy: 5.29592,
    r: 5.29592,
    transform: "matrix(-1 0 0 1 113.551 125.735)",
    fill: "#E26824"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeDots);
export default __webpack_public_path__ + "static/media/orange-dots.1d664bbc0941ce2b2bcbfec34b601e50.svg";
export { ForwardRef as ReactComponent };